import { Typography } from '@mui/material';
import { memo } from 'react';
import FormSection from '@shared/components/FormSection';
import StyledTextField from '@shared/components/StyledTextField';

const ContactInfo = ({ formik }) => {
  return (
    <FormSection
      title={'Datos de contacto'}
      id={'contactInfo'}
      customLayout={{
        md: {
          1: 12,
          2: 6,
          3: 6,
        },
      }}
    >
      <Typography
        style={{
          fontSize: '16px',
          color: '#000',
        }}
      >
        Los datos que nos brindes serán fundamental para que gestiones tu
        reserva y recibas información importante sobre tu viaje.
      </Typography>
      <StyledTextField
        label={'E-mail'}
        name={`contactInfo.email`}
        formik={formik}
      />

      <StyledTextField
        label={'Confirme E-mail'}
        name={`contactInfo.repeatEmail`}
        formik={formik}
      />
    </FormSection>
  );
};

export default memo(ContactInfo);
